import {
  SignMeasurements,
  SignMeasurementsChoices
} from '../model/sign/enums/sign-measurements';
import { SignShapeTypesChoices } from '../model/sign/enums/sign-shape-type';
import { SignTypesChoices } from '../model/sign/enums/sign-type';
import { SignDetail } from '../model/sign/sign-detail';
import { IP_BOARD_SIGN_MEASUREMENTS_CHOICES } from '../pages/products/detail/sign-placement-price/sign-placement-price-detail-helper';
import { StringHelper } from './string-helper';
import { IpBoardMeasurement } from '../shared/project-components/client-project-form/base-project/client-ip-board-form/helper/IpBoardMeasurement';

export class SignHelper {
  private constructor() {}

  static areValidSignDimensions(width: number, height: number): boolean {
    if (width == null || height == null) {
      return false;
    }
    return (
      this.matchUprightOrLyingDown(
        SignMeasurementsChoices.W50_H140,
        width,
        height
      ) ||
      this.matchUprightOrLyingDown(
        SignMeasurementsChoices.W70_H100,
        width,
        height
      ) ||
      this.matchUprightOrLyingDown(
        SignMeasurementsChoices.W70_H180,
        width,
        height
      ) ||
      this.matchUprightOrLyingDown(
        SignMeasurementsChoices.W100_H140,
        width,
        height
      )
    );
  }

  static getMatchingSignMeasurements(
    width: number,
    height: number
  ): SignMeasurements {
    if (width == null || height == null) {
      return null;
    }
    if (
      this.matchUprightOrLyingDown(
        SignMeasurementsChoices.W50_H140,
        width,
        height
      )
    ) {
      return SignMeasurementsChoices.W50_H140;
    }
    if (
      this.matchUprightOrLyingDown(
        SignMeasurementsChoices.W70_H100,
        width,
        height
      )
    ) {
      return SignMeasurementsChoices.W70_H100;
    }
    if (
      this.matchUprightOrLyingDown(
        SignMeasurementsChoices.W70_H180,
        width,
        height
      )
    ) {
      return SignMeasurementsChoices.W70_H180;
    }
    if (
      this.matchUprightOrLyingDown(
        SignMeasurementsChoices.W100_H140,
        width,
        height
      )
    ) {
      return SignMeasurementsChoices.W100_H140;
    }
    return null;
  }

  static areStandardIPBoardDimensions(width: number, height: number): boolean {
    if (width == null || height == null) {
      return false;
    }
    return (
      this.matchUprightOrLyingDown(
        IP_BOARD_SIGN_MEASUREMENTS_CHOICES.W70_H100,
        width,
        height
      ) ||
      this.matchUprightOrLyingDown(
        IP_BOARD_SIGN_MEASUREMENTS_CHOICES.W100_H140,
        width,
        height
      )
    );
  }

  private static matchUprightOrLyingDown(
    signMeasurements: SignMeasurements,
    width: number,
    height: number
  ) {
    return (
      (signMeasurements.width === width &&
        signMeasurements.height === height) ||
      (signMeasurements.width === height && signMeasurements.height === width)
    );
  }

  // Precondition: height > width for all SignMeasurements
  static getSignOrientationDisplay(
    sign: SignDetail,
    withSpaces = true,
    showLeftUnit = true,
    showRightUnit = true
  ): string {
    if (sign == null || sign.signMeasurements == null) {
      return '';
    }
    return this.getSignOrientationDisplayPipeable(
      sign.signMeasurements.width,
      sign.signMeasurements.height,
      sign.shape != null &&
        sign.shape.value === SignShapeTypesChoices.UPRIGHT.value,
      withSpaces,
      showLeftUnit,
      showRightUnit
    );
  }

  // Precondition: height > width for all SignMeasurements
  static getSignOrientationDisplayPipeable(
    signMeasurementsWidth: number,
    signMeasurementsHeight: number,
    signShapeIsUpright: boolean,
    withSpaces = true,
    showLeftUnit = true,
    showRightUnit = true
  ) {
    if (signMeasurementsWidth == null || signMeasurementsHeight == null) {
      return '';
    }

    const separator = `${withSpaces ? ' ' : ''}x${withSpaces ? ' ' : ''}`;

    const left: number = signShapeIsUpright
      ? signMeasurementsHeight
      : signMeasurementsWidth;
    const right: number = signShapeIsUpright
      ? signMeasurementsWidth
      : signMeasurementsHeight;

    return StringHelper.join(
      [
        showLeftUnit ? `${left} cm` : left + '',
        showRightUnit ? `${right} cm` : right + ''
      ],
      separator
    );
  }

  static stockSignIsAdhesive(sign: SignDetail): boolean {
    return (
      sign != null &&
      sign.type != null &&
      sign.type.value === SignTypesChoices.STICKER.value
    );
  }

  // return[0] is width, return[1] is height
  static getActualAdhesiveBoardDimensions(
    width: number,
    height: number
  ): number[] {
    return [width, height];
  }

  static getActualSizes(signDetail: SignDetail): IpBoardMeasurement {
    if (signDetail == null || signDetail.shape == null) {
      return;
    }
    const isUpright =
      signDetail.shape.value === SignShapeTypesChoices.UPRIGHT.value;
    return {
      height: isUpright
        ? signDetail.signMeasurements.height
        : signDetail.signMeasurements.width,
      width: isUpright
        ? signDetail.signMeasurements.width
        : signDetail.signMeasurements.height
    };
  }
}
